const mensajes = {
    // DocumentoValorTotal
    'DocumentoValorTotal.Titulo': 'Total documento',
};

export default mensajes;
